import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './EditReview.css';

// Component
import AdminReviewsForm from '../../../components/siteadmin/AdminReviewsForm';
import { withQuery } from '../../../hoc/withGraphql';
import Loader from '../../../components/Loader/Loader';

// Query
import editAdminReviewsQuery from './editAdminReview.graphql';

class EditReview extends React.Component {

    static propTypes = {
        title: PropTypes.string.isRequired,
        reviewId: PropTypes.number.isRequired
    };

    static defaultProps = {
        data: {
            loading: true
        }
    };

    render() {
        const { data: { loading, editAdminReview }, reviewId } = this.props;
        if (loading) {
            return <Loader type={"text"} />
        } else {
            return (
                <AdminReviewsForm initialValues={editAdminReview} />
            );
        }
    }
}

export default compose(
    withStyles(s),
    withQuery(editAdminReviewsQuery,
        {
            options: (props) => ({
                variables: {
                    reviewId: props.reviewId,
                },
                fetchPolicy: 'network-only',
                ssr: false
            })
        }
    )
)(EditReview);